/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Aim_Hint_Software_ZoomInputs */

const vi_mobile_scan_aim_hint_software_zoom = /** @type {(inputs: Mobile_Scan_Aim_Hint_Software_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữ máy ra xa cho nét`)
};

/**

* @param {Mobile_Scan_Aim_Hint_Software_ZoomInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_aim_hint_software_zoom = /** @type {((inputs?: Mobile_Scan_Aim_Hint_Software_ZoomInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Aim_Hint_Software_ZoomInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_scan_aim_hint_software_zoom(inputs)
});